import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../../utils/propTypes';

import Modal from '../Modal';
import Spinner from '../Spinner';

import ManufacturerPlanView from './components/ManufacturerPlanView';
import VendorPlanView from './components/VendorPlanView';
import ErrorView from './components/ErrorView';

import { actionCreators as modalActions } from '../../../redux/PlanModal/actions';

import { TYPE_MANUFACTURER, TYPE_VENDOR } from '../../../utils/plans';

import styles from './styles.scss';


function PlanModal({
  plan, error, loading, open, closePlanModal, loadAccountPlan,
}) {
  return (
    <Modal open={open} onClose={closePlanModal}>
      <Spinner isLoading={loading} className={styles.spinner}>
        {plan && plan.type === TYPE_MANUFACTURER && <ManufacturerPlanView plan={plan} />}
        {plan && plan.type === TYPE_VENDOR && <VendorPlanView plan={plan} />}
        {error && <ErrorView onRetry={loadAccountPlan} />}
      </Spinner>
    </Modal>
  );
}

PlanModal.propTypes = {
  plan: AppPropTypes.companyPlan,
  // eslint-disable-next-line react/forbid-prop-types
  error: PropTypes.any,
  loading: PropTypes.bool,
  open: PropTypes.bool,
  closePlanModal: PropTypes.func.isRequired,
  loadAccountPlan: PropTypes.func.isRequired,
};

PlanModal.defaultProps = {
  plan: null,
  error: null,
  loading: false,
  open: false,
};

function mapStateToProps(state) {
  return state.planModal;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(modalActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanModal);



// WEBPACK FOOTER //
// ./src/app/components/PlanModal/index.js